/**
 * Format helpers — shared between GlobalSupervisionTab and its sub-parts.
 * Extracted from the monolithic 409-line file on 29/05/2026 to keep
 * the formatting logic in a single place.
 */
export const fmtMoney = (n) =>
  n == null ? '—' : Math.round(n).toLocaleString('fr-FR') + ' €';

export const fmtNum = (n) =>
  n == null ? '—' : Math.round(n).toLocaleString('fr-FR');
